import React from "react"
import { Chip } from "@material-ui/core"
import useStyles from "@/components/FeatureStatusChip/styles"

type FeatureStatus = "new" | "upcoming"

type FeatureInfo = {
	text: string
	className: string
}

type FeatureStatusToFeatureInfo = Record<FeatureStatus, FeatureInfo>

type FeatureStatusChipProps = {
	status: FeatureStatus
	className?: string
}

const FeatureStatusChip: React.FC<FeatureStatusChipProps> = (props) => {
	const {
		status,
		className
	} = props

	const classes = useStyles()

	const featureStatusToFeatureInfo: FeatureStatusToFeatureInfo = {
		new: {
			text: "Novo",
			className: classes.new
		},
		upcoming: {
			text: "Em breve",
			className: classes.upcoming
		}
	}

	const featureInfo = featureStatusToFeatureInfo[status]

	return (
		<Chip
			size="small"
			label={featureInfo.text}
			className={`${className} ${classes.container} ${featureInfo.className}`}
		/>
	)
}

export default FeatureStatusChip
